module.exports = __webpack_public_path__ + "../resources/images/illustration_trash-b9f45ff26fea160cec8cb9f9c6db5373.svg";